import { useContext } from "react";
import { Modal } from "react-overlays";
import OsteopataContext from "../../context/osteopata";
import Icon from "../icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const OsteopataDiscardRequestModal = ({ discardModal, setDiscardModal }) => {
  const { labels, setCurrentRequest } = useContext(OsteopataContext);
  const closeModal = () => setDiscardModal(false);

  const handleDiscardRequest = () => {
    setCurrentRequest();
    closeModal();
  };

  return (
    <Modal
      show={!!discardModal}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_OSTEOPATA_DISCARD_MODAL_TITLE || "Vuoi cancellare la richiesta?"}
          </h1>

          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_OSTEOPATA_NO || "No"}
            </button>
            <button className="button primary" onClick={handleDiscardRequest}>
              {labels?.WELFARE_OSTEOPATA_YES_DISCARD || "Sì, cancella"}
              <Icon name="trash" />
            </button>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default OsteopataDiscardRequestModal;
